import React from 'react';
import { prepareData } from 'utils/googleData';

export function SimpleFeatures(props) {
    const { enable, items } = prepareData({ props });
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>;
    }

    return (
        <div className="features-section px-4 sm:px-6 lg:px-8 py-8 bg-gray-50 dark:bg-gray-800">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {items.map((feature, index) => {
                    const Icon = feature.Icon;
                    return (
                        <div key={index} className="feature-card flex flex-col items-start p-4 bg-white dark:bg-red shadow-lg rounded-lg hover:bg-blue-50 dark:hover:bg-gray-700 transition-colors duration-300">
                            {Icon && (
                                <div className="icon-container mb-3">
                                    <Icon className={`icon h-12 w-12 ${feature.className || ''}`} />
                                </div>
                            )}
                            <h3 className="feature-title text-lg font-semibold text-gray-800 dark:text-white">{feature.title}</h3>
                            <p className="feature-description text-sm text-gray-600 dark:text-gray-300">{feature.description}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default SimpleFeatures;
